// تصدير بيانات الجداول إلى ملف CSV يفتح مباشرة في Excel.
// نستخدم CSV بدل xlsx لأنه لا يحتاج أي مكتبة إضافية ويدعم العربية عبر BOM.

// الخلايا التي تبدأ بـ = أو + أو @ يفسّرها Excel كصيغة (formula injection)،
// فنسبقها بفاصلة عليا حتى تُعرض كنص كما هي.
const RISKY_PREFIX = /^[=+@\t\r]/;

const escapeCell = (value) => {
  if (value === null || value === undefined) return '""';

  let text = String(value);
  if (RISKY_PREFIX.test(text)) {
    text = `'${text}`;
  }

  return `"${text.replace(/"/g, '""')}"`;
};

export const buildCsv = (headers, rows) =>
  [headers, ...rows].map((row) => row.map(escapeCell).join(",")).join("\r\n");

/**
 * ينزّل ملف CSV في المتصفح.
 * @param {string} fileName اسم الملف بدون امتداد
 * @param {string[]} headers عناوين الأعمدة
 * @param {Array<Array<*>>} rows الأسطر بنفس ترتيب العناوين
 */
export const downloadCsv = (fileName, headers, rows) => {
  // BOM ضروري حتى يقرأ Excel المحارف العربية بشكل صحيح
  const blob = new Blob(["\uFEFF", buildCsv(headers, rows)], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// لاحقة تاريخ لاسم الملف: 2026-08-29
export const todayStamp = () => new Date().toISOString().slice(0, 10);
